import { CreateActivityInput, TimeActivity } from '../models/activity.model';

export abstract class ActivitiesRepository {
  abstract getActivities(): Promise<TimeActivity[]>;
  abstract getActivityDomains(): Promise<Array<{ id: number; domainId: number | null }>>;
  abstract assignActivityDomain(id: number, domainId: number): Promise<void>;
  abstract createActivity(input: CreateActivityInput): Promise<TimeActivity>;
  abstract renameActivity(id: number, name: string): Promise<void>;
  abstract setActivityArchived(id: number, archived: boolean): Promise<void>;
}
